import DeviceThermostatOutlinedIcon from "@mui/icons-material/DeviceThermostatOutlined";
import controlLoopServices from "app/services/automations/control-loop-services";
import ControlLoopEditor from "./ControlLoopEditor";
import { ControlLoopCardDetails, ControlLoopCardSummary, controlLoopStatusChip, controlLoopSubtitle } from "./ControlLoopSummary";

// Controles «Mantener en rango» (ControlLoop en el backend).
const controlLoopType = {
    key: "control_loop",
    label: "Mantener en rango",
    pickerTitle: "Mantener una variable en rango",
    pickerDescription: "Enciende y apaga una salida para mantener una medición (temperatura, humedad, CO₂…) entre un mínimo y un máximo.",
    icon: DeviceThermostatOutlinedIcon,
    order: 20,
    Editor: ControlLoopEditor,
    CardSummary: ControlLoopCardSummary,
    CardDetails: ControlLoopCardDetails,
    subtitle: controlLoopSubtitle,
    statusChip: controlLoopStatusChip,
    setEnabled: (item, enabled) => controlLoopServices.updateControlLoop(item.id, { enabled }),
    remove: (item) => controlLoopServices.deleteControlLoop(item.id),
    confirmRemove: (item) => `¿Eliminar el control "${item.name}"? La salida vuelve a su estado seguro.`,
    canDuplicate: true,
    draftTypes: ["control_loop"],
    draftTarget: (message) => {
        const payload = message?.draft_payload || {};
        return payload.mode === "update" ? (payload.target_id || payload.control_loop?.id || null) : null;
    },
};

export default controlLoopType;
